// src/components/views/reports-view/basic-reports.tsx

import CallsSummaryDailyChart from 'src/components/molecules/charts/calls-summary-daily-chart/calls-summary-daily-chart';
import CallsSummaryWeeklyChart from 'src/components/molecules/charts/calls-summary-weekly-chart/calls-summary-weekly-chart';
import AgentCallsDailyChart from 'src/components/molecules/charts/agent-calls-daily-chart/agent-calls-daily-chart';
import AgentCallsWeeklyChart from 'src/components/molecules/charts/agent-calls-weekly-chart/agent-calls-weekly-chart';
import CallsSummaryMonthlyChart from 'src/components/molecules/charts/calls-summary-monthly-chart/calls-summary-monthly-chart';
import AgentCallsMonthlyChart from 'src/components/molecules/charts/agent-calls-monthly-chart/agent-calls-monthly-chart';
import type { DailyCallSummary } from 'src/api/generated';

interface BasicReportsProps {
  summaries: DailyCallSummary[];
}

const BasicReports: React.FC<BasicReportsProps> = ({ summaries }) => {
  return (
    <div className="grid gap-4 xl:grid-cols-2">
      <div className="min-w-0">
        <CallsSummaryDailyChart summaries={summaries} />
      </div>
      <div className="min-w-0">
        <AgentCallsDailyChart summaries={summaries} />
      </div>
      <div className="min-w-0">
        <CallsSummaryWeeklyChart summaries={summaries} />
      </div>
      <div className="min-w-0">
        <AgentCallsWeeklyChart summaries={summaries} />
      </div>
      <div className="min-w-0">
        <CallsSummaryMonthlyChart summaries={summaries} />
      </div>
      <div className="min-w-0">
        <AgentCallsMonthlyChart summaries={summaries} />
      </div>
    </div>
  );
};

export default BasicReports;
